/**
 * tr.ts — TR: documento gerado, edição e geração a partir do ETP (F6b).
 */

import type { components } from './generated/api'
import { api } from './http'

export type DocumentoTR = components['schemas']['DocumentoTR']
export type SecaoTR = components['schemas']['SecaoTR']
export type FormularioTR = components['schemas']['FormularioTR']
export type NovoTR = components['schemas']['NovoTR']
export type GeracaoTR = components['schemas']['GeracaoTR']

export function documentoTR(id: number) {
  return api<DocumentoTR>(`/api/v1/tr/${id}`)
}

export function formularioTR(id: number) {
  return api<FormularioTR>(`/api/v1/tr/${id}/formulario`)
}

export function salvarTR(id: number, secoes: Record<string, string>) {
  return api<DocumentoTR>(`/api/v1/tr/${id}`, {
    method: 'PUT',
    body: { id, secoes },
  })
}

export function excluirTR(id: number) {
  return api<{ tinha_edital: boolean }>(`/api/v1/tr/${id}`, { method: 'DELETE' })
}

export function novoTR(id: number) {
  return api<NovoTR>(`/api/v1/tr/${id}/novo`)
}

export function gerarTR(id: number) {
  return api<GeracaoTR>(`/api/v1/tr/${id}/gerar`, { method: 'POST' })
}
